"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  en: {
    hasResults: 'Some results are available',
    loading: 'Searching...',
    noResults: 'No results found'
  },
  fr: {
    hasResults: 'Quelques suggestions sont disponible',
    loading: 'Recherche...',
    noResults: 'Aucun résultat trouvé'
  }
};